import { render, staticRenderFns } from "./TinySwatch.vue?vue&type=template&id=6c8c7551&scoped=true&"
import script from "./TinySwatch.vue?vue&type=script&lang=js&"
export * from "./TinySwatch.vue?vue&type=script&lang=js&"
import style0 from "./TinySwatch.vue?vue&type=style&index=0&id=6c8c7551&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8c7551",
  null
  
)

export default component.exports